import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=743a338a&scoped=true&"
var script = {}
import style0 from "./FAQ.vue?vue&type=style&index=0&id=743a338a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743a338a",
  null
  
)

export default component.exports